import React from "react";
import { NavLink, Link } from "react-router-dom";
import Logo from "../../assets/assets/Nibss-Logo.png";

const Navbar = () => {
  return (
    <nav>
      <div className="nav-left">
        <Link to="/">
          <div className="nav-left-logo">
            <img src={Logo} alt="nibss-logo" />
          </div>
        </Link>
      </div>

      <input type="checkbox" id="nav-check" />
      <div className="nav-dropdown">
        <NavLink to="/sign-up" className="sign-in">
          <span>Get Started</span>
        </NavLink>

        <NavLink to="/login">
          <button className="nav-button">Sign In</button>
        </NavLink>
      </div>

      <div className="nav-mid">
        <label htmlFor="nav-check">
          <div className="nav-mid-item1"></div>
          <div className="nav-mid-item2"></div>
          <div className="nav-mid-item3"></div>
        </label>
      </div>

      <div className="nav-right">
        <NavLink to="/sign-up" className="sign-in">
          <span>Get Started</span>
        </NavLink>

        <NavLink to="/login">
          <button className="nav-button">Sign In</button>
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
